import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Device } from '@ionic-native/device/ngx';
import { NetworkInterface } from '@ionic-native/network-interface/ngx';
import { Platform } from '@ionic/angular';
import { File } from '@ionic-native/file/ngx';
import { Storage } from '@ionic/storage';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonDeclarationService {
  runPlatform: any;
  LanguageJson: any;
  Networkstatus: any = true;
  baseUrl: any;
  versionUrl: any;
  apiUrl: any;
  channelId: string;
  Ipaddress: any;
  metadata: any;
  ChatFullHistory: any = [];
  speechrate: any;
  enablevoice: any;
  enabletackback: any;
  tackbackPage: any = "/va/chat";
  profileImg: any;
  versionNo: any;
  buildNo: any;
  DataStore: any;
  howtouse: any;
  TalismaValues: any = 0;
  cordovaSupport: any;
  BrowserBuild: any;
  DefaultPolicyBlock: any = false;
  ChatpushData: any;
  TamlismaJson: any;
  functionCall: any;
  parampassing: any;
  loginCheck: any;
  loaderenable: boolean = false;
  Actionsheetenable: boolean = false;
  ChatfullList: any = [];
  contextualMenu: any;
  capsuleList: any = [];
  chatHeaderheading: any;
  contentscroll: any;
  loginedFlg: any;
  grammercontent: any = {};
  chatplaceholder: any = '';
  jumppopup: any = '';
  miclbl: any = '';
  BcknomineeList: any;
  buildflg: boolean;
  lblButtons: any;
  HeaderType: any;
  searchplaceholder: any;
  closeBankImg: BehaviorSubject<{}> = new BehaviorSubject<{}>({});
  youtubelist: any = [];
  checkMobileAuth: boolean;
  checkMobileNumberEntered: boolean;
  checkOtpEntered: boolean;
  static minimizeBot: any = 'BOT-MINIMIZE';
  static minimizebotValue : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  static minimizeToggle: boolean;
  static showHideChat: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(public http: HttpClient, public device: Device, public networkInterface: NetworkInterface, public platform: Platform, public file: File, public storage: Storage) {
    this.buildNo = "02";
    this.buildflg = false;
    this.versionNo = "1.0.5";

    // This should be 0 for Android and ios 
    // This should be 1 for Browser
    this.BrowserBuild = 1;

    //PROD
    this.baseUrl = "https://khushi.uniphore.com/";

    // UAT 115
    // this.baseUrl = "https://akeiradev.uniphore.com/";

    // this.versionUl = "Metlifev2/";

    this.versionUrl = "Metlife/";
    this.apiUrl = "Services/Webbotservice/";

    if (this.BrowserBuild == 1)
      this.cordovaSupport = false;
    else
      this.cordovaSupport = this.platform.is('cordova');

    this.platform.ready().then(() => {
      this.profileImg = "assets/images/profile_icon.png";
      this.Speacksetup();
      if (this.BrowserBuild == 1) {
        this.http.get("http://api.ipify.org/?format=jsonp&callback=JSONP_CALLBACK", { responseType: 'text' }).subscribe(data => {
          this.Ipaddress = data;
          let num = this.Ipaddress.indexOf(":");
          let num2 = this.Ipaddress.indexOf("\"});");
          this.Ipaddress = this.Ipaddress.slice(num + 2, num2);
          this.setMetdata();
        }, err => {
          
          this.setMetdata();
        })
      } else {
        this.networkInterface.getWiFiIPAddress()
          .then(address => {
            this.Ipaddress = address.ip;
            console.info(`IP: ${address.ip}, Subnet: ${address.subnet}`)
            this.setMetdata();
          })
          .catch(error => {
            
            this.setMetdata();
          });
      }
      if (localStorage.language == undefined)
        this.getJson("en", "set")
      else
        this.getJson(localStorage.language, "set")
    });
  }

  static minimizeChat(emitvalue:boolean) {
    if(CommonDeclarationService.minimizebotValue){
      
      CommonDeclarationService.minimizeToggle = !CommonDeclarationService.minimizeToggle;
      CommonDeclarationService.showHideChat.next(CommonDeclarationService.minimizeToggle);
      CommonDeclarationService.minimizebotValue.next(emitvalue);
      let msg = {
        'type': 'BOT-MINIMIZE',
        'data': '{"w":"75px","h":"65px"}'
      };
      
      
      window.parent.postMessage(msg, "*");
    }
  }

  getJson(lang: any, flg: any) {
    var file: any;
    let req: any;
    let res: any;
    req = {
      langCode: lang,
      metadata: {
        "channelId": "1" || "",
        "ip": "",
        "imei": "",
        "platform": "Android",
        "deviceVersion": "7.0",
        "deviceModel": "Android Mobile",
        "version": this.versionNo
      }
    }
    file = 'assets/json/lang_' + lang + '.json';
    this.getgrammerData(lang, req);
    return new Promise(async resolve => {
      // if (this.Networkstatus || this.Networkstatus == undefined) {
      //   await this.http.post(this.baseUrl + this.versionUrl + this.apiUrl + "getLanguageJson", req).subscribe(data => {
      //     res = data;
      //     if (flg == "set") {
      //       this.LanguageJson = res.FileContent;
      //       localStorage.languageJson = JSON.stringify(res.FileContent);
      //     }
      //     resolve(res.FileContent);
      //   }, async err => {
      //   await this.http.get(file).subscribe(
      //     data => {
      //       if (flg == "set") {
      //         this.LanguageJson = data;
      //         localStorage.languageJson = JSON.stringify(data);
      //       }
      //       resolve(data);
      //     }, err => {
      //       
      //     })
      //   })
      // } else {     
        await this.http.get(file).subscribe(
          data => {
            if (flg == "set") {
              this.LanguageJson = data;
              localStorage.languageJson = JSON.stringify(data);
            }
            resolve(data);
          }, err => {
            
          })
      // }
    });
  }

  async getgrammerData(lang, req) {
    // if (this.Networkstatus || this.Networkstatus == undefined) {
    //   await this.http.post(this.baseUrl + this.versionUrl + this.apiUrl + "getGrammarJson", req).subscribe((data: any) => {
    //     
    //     if (data.FileContent != undefined && data.FileContent != [] && data.FileContent != '')
    //       this.grammercontent = data.FileContent[lang];
    //     
    //   }, err => {
    //     
    //     this.http.get("assets/json/grammer.json").subscribe((data: any) => {
    //       this.grammercontent = data[lang];
    //     }, err => {
    //       
    //     })
    //   })
    // } else {
      this.http.get("assets/json/grammer.json").subscribe((data: any) => {
        this.grammercontent = data[lang];
        var key, keys = Object.keys(this.grammercontent);
        var n = keys.length;
        var newobj = {}
        while (n--) {
          key = keys[n];
          newobj[key.toLowerCase()] = this.grammercontent[key];
        }
        
      }, err => {
        
      })
    // }
  }

  setMetdata() {
    let version: any;
    if (this.buildflg == true)
      version = this.versionNo + " Build " + this.buildNo
    else
      version = this.versionNo

    this.metadata = {
      "channelId": this.channelId || "",
      "ip": this.Ipaddress || "",
      "imei": this.device.uuid || "",
      "platform": "Webbot",
      "deviceVersion": this.device.version || "",
      "deviceModel": this.device.model || "",
      "version": version
    };
    
  }

  public Speacksetup() {
    if (localStorage.voiceenable == undefined)
      localStorage.voiceenable = false;
    if (localStorage.tackbackenable == undefined)
      localStorage.tackbackenable = false;
    if (localStorage.speechrate == undefined)
      localStorage.speechrate = "0";
    this.enablevoice = localStorage.voiceenable;
    this.enabletackback = localStorage.tackbackenable;
    this.speechrate = localStorage.speechrate;
  }

  public Amazonpoliy(textData) {
    return new Promise((resolve, reject) => {
      this.http.post("https://r7cssgk5ml.execute-api.ap-south-1.amazonaws.com/dev/speak", textData).subscribe(res => {
        
        resolve(res);
      }, err => {
        
        reject(err);
      })
    })
  }


  StoreChatHistory() {
    let res: any;
    if (this.BrowserBuild == 1) {
      this.storage.set("chatData", JSON.stringify(this.ChatFullHistory))
    } else {
      res = JSON.stringify(this.ChatFullHistory);
      this.file.writeFile(this.file.dataDirectory, 'chat.json', res, { replace: true })
        .then(_ => console.log('Directory exists'))
        .catch(err => {
          console.log(err);
        });
    }

  }

  public getChatHistory() {
    let chat: any = [];
    return new Promise(resolve => {
      if (this.BrowserBuild == 1) {
        this.storage.get("chatData").then(ch => {
          if (ch == null || ch == "" || ch == undefined) {
            this.StoringFullData(chat);
            resolve(chat);
          } else {
            this.StoringFullData(JSON.parse(ch));
            resolve(JSON.parse(ch));
          }
        }, err => {
          this.StoringFullData(chat);
          resolve(chat);
        })
      }
      else {
        this.file.checkFile(this.file.dataDirectory, "chat.json").then(data => {
          this.file.readAsText(this.file.dataDirectory, "chat.json").then(data => {
            chat = JSON.parse(data);
            this.StoringFullData(JSON.parse(data));
            resolve(chat);
          }, err => {
            this.StoringFullData(chat);
            resolve(chat);
          })
        }, err => {
          this.StoringFullData(chat);
          resolve(chat);
        })
      }
    });
  }

  public StoringFullData(conversation: any) {
    this.ChatFullHistory = conversation;
  }


  public deletefile() {
    if (this.BrowserBuild == 1)
      this.storage.remove("chatData");
    else {
      this.file.checkFile(this.file.dataDirectory, "chat.json").then(data => {
        this.file.removeFile(this.file.dataDirectory, "chat.json").then(data => {
          console.log(data);
        });
      });
    }
  }

  public storeProcess(content: any, key: any) {
    this.storage.set(key, JSON.stringify(content))
  }

  public deleteProcess(key: any) {
    this.storage.remove(key);
  }

  public getstoreProcess(key: any) {
    let data = [];
    return new Promise(async resolve => {
      await this.storage.get(key).then(resp => {
        if (resp == null || resp == undefined)
          resolve(data);
        else
          resolve(JSON.parse(resp));
      }, err => {
        resolve(data);
      })
    })
  }

  Scrollbottom() {
    this.contentscroll.scrollToBottom(300);
  }
}